import React from "react";
import {
  HomePage,
  AboutPage,
  GloryPage,
  BlogPage,
  LiteraturePage,
  EventsPage,
  ContactUsPage,
  NoPageFoundPage,
  Sponsi,
} from "./pages";
import EventInfo from "./pages/eventsPage/EventInfo";
import { Switch, Route } from "react-router-dom";
import { OuterWrapper } from "./components";
import "bear-react-carousel/dist/index.css";
const App = () => {
  return (
    <OuterWrapper>
      <Switch>
        <Route exact path="/" component={AboutPage} />
        {/* <Route path="/about" component={AboutPage} /> */}
        <Route path="/glory" component={GloryPage} />
        <Route path="/events" component={EventsPage} />
        <Route path="/contact" component={ContactUsPage} />
        <Route path="/sponsors" component={Sponsi} />
        <Route path="/event_information" component={EventInfo} />
        <Route component={NoPageFoundPage} />
      </Switch>
    </OuterWrapper>
  );
};

export default App;
